import produce, { Draft } from "immer";

import { Rateplan, RateplanService, CancellationCondition } from "../common/types/rateplan";

type State = {
  rateplans: {
    [rateplanId: string]: Rateplan
  }
  rateplanServices: {
    [rateplanId: string]: RateplanService
  }
  rateplansList: Rateplan[]
  rateplanServicesList: RateplanService[]
  cancellationConditionsList: CancellationCondition[]
  cancellationConditions: {
    [id: string]: CancellationCondition
  }
}

const rateplan = {
  state: {
    rateplans: {},
    rateplanServices: {},
    rateplansList: [],
    rateplanServicesList: [],
    cancellationConditionsList: [],
    cancellationConditions: {}
  } as State,
  reducers: {
    load: produce((draft: Draft<State>, payload: State) => {
      Object.assign(draft, payload)
      draft.rateplans = payload.rateplansList.reduce((acc, current) => {
        return {...acc, [current.id]: current }
      }, {})
      draft.rateplanServices = payload.rateplanServicesList.reduce((acc, current) => {
        return {...acc, [current.rateplanId]: payload.rateplanServicesList.filter(service => service.rateplanId === current.rateplanId) }
      }, {}) // TODO: à virer si pas besoin
      draft.cancellationConditions = payload.cancellationConditionsList.reduce((acc, current) => {
        return {...acc, [current.id]: current }
      }, {})
    })
  }
}



export default rateplan